module.exports = __webpack_public_path__ + "static/img/operations05.a5216db.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/operations05.png
// module id = rZVK
// module chunks = 0